import { getMenuGroupRoutes } from './modules/groups';
import { getScreenRoutes } from './modules/screens';
import { getMenuRoutes } from './modules/menus';

const getAllRoutes = () => ({
  ...getMenuGroupRoutes(),
  ...getScreenRoutes(),
});

const filterAvailableRoutes = (routeArray, availablePaths) => routeArray.filter((route) => availablePaths?.includes(route.path));
export const getRouteTitle = (path) => Object.values(getAllRoutes()).find((route) => route.path === path)?.title || "";
export const getAvailableRoutes = (availablePaths) => filterAvailableRoutes(Object.values(getAllRoutes()), availablePaths);
export const getAvailableMenuRoutes = (availablePaths) => {
  const filteredMenuRoutes = [];

  getMenuRoutes().forEach((menu) => {
    const availableMenuChildren = filterAvailableRoutes(menu.children, availablePaths);
    if (availableMenuChildren.length) {
      filteredMenuRoutes.push({
        parent: menu.parent,
        children: availableMenuChildren,
      })
    }
  })

  return filteredMenuRoutes;
};